/**
 * @file Hides the investments input and every profile input that comes
 * after the field that is blocking the investment.
 */
import { TYPE_NONE } from "@components/Form";
import { INVESTMENT_PROFILE_FIELD_MAP } from "@components/Domain";
import type { SchemaInput } from "@api";

import type { Investment } from "../types";

// NOTE: the position of the investments input in getInvestmentSchema.
const INVESTMENTS_INPUT_INDEX = 5;

/**
 * Hides the investments input and, from the blocking field onward, the
 * rest of the fields in the investor's profile schema.
 */
const extendBlockedInputs = (
  schema: SchemaInput[],
  investment: Investment,
  blockingFieldName?: string,
): void => {
  if (!blockingFieldName) {
    return;
  }

  schema[INVESTMENTS_INPUT_INDEX].type = TYPE_NONE;

  const { profileType } = investment;

  const profileFieldName = INVESTMENT_PROFILE_FIELD_MAP[profileType];
  const profileFieldIndex = schema.findIndex((input) => input.name === profileFieldName);

  const { schema: profileSchema } = schema[profileFieldIndex];

  let shouldSetNone = false;

  for (const input of profileSchema) {
    if (shouldSetNone) {
      input.type = TYPE_NONE;
    }

    if (input.name === blockingFieldName) {
      shouldSetNone = true;
    }
  }
};

export default extendBlockedInputs;
